exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-select.vs--multiple .vs__selected {\n  height: 1.6rem;\n}[dir] .v-select.vs--multiple .vs__selected {\n  background-color: #f8f8f8;\n  border: unset;\n}[dir=ltr] .v-select.vs--multiple .vs__selected {\n  margin-right: 0.5rem;\n}[dir=rtl] .v-select.vs--multiple .vs__selected {\n  margin-left: 0.5rem;\n}", ""]);

// exports
